import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage, usePopup } from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_DOC_CHNL_MGMT_INFO,
    SG_DOC_TRSC_INFO_LIST,
    SG_TANCIS_ED_RCVR_INFO_LIST,
} from "@/tra/tancis/ptli/elctdoc/chnl/services/PtliChnlMgmtService";
import { PTLI0705004Q } from "@/tra/tancis/ptli/elctdoc/chnl/PTLI0705004Q";
import { set } from "lodash";
/*
 * Update Channel
 * !== 채널 수정 ==!
 */
export const PTLI0705003S = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0046", "auth_ptli0047"],
    });
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { intfChnlId } = useParams();
    const [sndrcvDvnCd, setSndrcvDvnCd] = useState();
    const [trgtTpCd, setTrgtTpCd] = useState();
    const [chnlAplyPrcdStatCd, setChnlAplyPrcdStatCd] = useState();
    const [govesbUseYn, setGovesbUseYn] = useState<boolean>(false);

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0069" }, // 대상 유형 코드
            { area: "comnCd", comnCd: "COM0080" }, // 채널 신청 진행상태 코드
            { area: "comnCd", comnCd: "COM0064" }, // 활성화 여부 코드
            { area: "comnCd", comnCd: "COM0077" }, // 송수신 구분 코드
            { area: "comnCd", comnCd: "COM0071" }, // 연계 프로토콜 코드
            { area: "comnCd", comnCd: "COM0070" }, // 송수신 유형 코드
            { area: "comnCd", comnCd: "COM0083" }, // 연계인증 유형 코드
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        docChnlForm: useForm({
            defaultSchema: SF_DOC_CHNL_MGMT_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        docTrscList: useGrid({
            defaultSchema: SG_DOC_TRSC_INFO_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
        traEdRcvrInfoList: useGrid({
            defaultSchema: SG_TANCIS_ED_RCVR_INFO_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get Channel !== 채널 정보 조회 ==!
        getElctDocChnl: useFetch({
            api: () => APIS.getElctDocChnl(intfChnlId),
            enabled: !!intfChnlId,
            onSuccess: (data) => {
                const elctDocChnl = data.elctDocChnl.content;
                const elctDocTrscList = elctDocChnl.elctDocTrscList;
                const traEdRcvrInfoList = elctDocChnl.elctDocTrscList;

                setSndrcvDvnCd(elctDocChnl.sndrcvDvnCd);
                setTrgtTpCd(elctDocChnl.trgtTpCd);
                setChnlAplyPrcdStatCd(data.elctDocChnl.chnlAplyPrcdStatCd);
                handler.onChangeGovesbUseYn(elctDocChnl.govesbUseYn);

                form.docChnlForm.setValues(elctDocChnl);

                if (!comnUtils.isEmpty(elctDocTrscList)) {
                    elctDocTrscList.forEach((item: any) => {
                        // Recipient ID mapping in case of transmission !== 송신인 경우 수신자ID 매핑 ==!
                        if (elctDocChnl.sndrcvDvnCd === "A") {
                            item.trgtIntfChnlId = item.intfRcvrId;
                        } else {
                            item.trgtIntfChnlId = item.intfSndrId;
                        }
                    });

                    grid.docTrscList.setData(comnUtils.getGridData(elctDocTrscList));
                }
                if (!comnUtils.isEmpty(traEdRcvrInfoList)) {
                    grid.traEdRcvrInfoList.setData(comnUtils.getGridData(traEdRcvrInfoList));
                }

                if (form.docChnlForm.getValue("trgtTpCd") === "B" && form.docChnlForm.getValue("govesbUseYn") === "Y") {
                    grid.docTrscList.setEdit("cell", "apiCd", true);
                    grid.docTrscList.setEdit("cell", "pshCd", true);
                } else {
                    grid.docTrscList.setEdit("cell", "apiCd", false);
                    grid.docTrscList.setEdit("cell", "pshCd", false);
                }
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    const { errorMessage } = error.response.data;

                    modal.openModal({
                        content: errorMessage.content,
                        onConfirm: () => {},
                        close: false,
                    });

                    return;
                }

                toast.showToast({ type: "error", content: "msg.com.00018" }); // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),
        // Update Channel !== 채널 수정 ==!
        updateElctDocChnl: useFetch({
            api: (data) => APIS.updateElctDocChnl({ ...data }),
            onSuccess: (res) => {
                modal.openModal({
                    content: "msg.com.00062", // Successfully saved., !== 정상적으로 저장되었습니다. ==!
                    onConfirm: () => {
                        const intfChnlId = res.chnlInfo.content.intfChnlId;
                        fetch.getElctDocChnl.fetch(intfChnlId);
                    },
                    close: false,
                });
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    form.docChnlForm.setErrors(error.response.data.errors);
                }

                modal.openModal({
                    content: "msg.00006", // An error occurred during processing.
                });
            },
        }),
        // delete channel !== 채널 삭제 ==!
        deleteElctDocChnl: useFetch({
            api: () => APIS.deleteElctDocChnl(intfChnlId, form.docChnlForm.getValues()),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.com.00060", // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                    onCancel: () => {
                        navigate(URLS.ptli0705001q);
                    },
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // on Save Button Click Event Handler  !== 문서함 수정 ==!
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.docChnlForm.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.docChnlForm.handleSubmit(
                () => {
                    const data = form.docChnlForm.getValues();
                    const elctDocTrscList = grid.docTrscList.getData();

                    // Setting Transaction List !== 트랜잭션 목록 세팅 ==!
                    data.elctDocTrscList = elctDocTrscList;

                    // Check the reason for rejection when returning a product !== 반려 시 반려사유 체크  ==!
                    if (data.chnlAplyPrcdStatCd === "D" && comnUtils.isEmpty(data.rtrnRsn)) {
                        toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                        form.docChnlForm.setFocus("rtrnRsn");
                        return;
                    }

                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.updateElctDocChnl.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                },
            )();
        },
        // on Grid Add Button Click Event Handler !== 그리드 추가 클릭 ==!
        onGridAddBtnClick: () => {
            const modalCallback = (list: any[]) => {
                if (!comnUtils.isEmpty(list)) {
                    list.forEach((item: any) => {
                        const arrRowData = grid.docTrscList.getAddedData();

                        // Add only if data is not in the existing grid !== 기존 그리드에 없는 데이터인 경우에만 추가 ==!
                        if (!comnUtils.isEmptyArray(arrRowData)) {
                            const bExist = arrRowData.some((rowData: any) => {
                                return rowData.intfId === item.intfId;
                            });

                            if (bExist) return;
                        }

                        grid.docTrscList.addRow({ ...item });
                        grid.traEdRcvrInfoList.addRow({ ...item });
                    });
                }

                modal.closeModal();
            };

            modal.openModal({
                draggable: true,
                size: "md",
                content: <PTLI0705004Q callback={modalCallback} sndrcvDvnCd={sndrcvDvnCd} />,
            });
        },
        // Delete document target list deletion event !== 문서 대상 목록 삭제 이벤트 ==!
        click_Btn_DeleteGridDocTrscList: () => {
            const seltList: any[] = grid.docTrscList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.00004" });
                return;
            }

            modal.openModal({
                content: "msg.00103",
                onConfirm: () => {
                    grid.docTrscList.deleteRow("checkbox");
                },
            });
        },
        // Delete Channel !== 채널 삭제 ==!
        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.com.00049", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => {
                    fetch.deleteElctDocChnl.fetch();
                },
            });
        },
        // onChangeGovesbUseYn Event Handler !== Govesb 사용여부 변경 이벤트 ==!
        onChangeGovesbUseYn: (value: string) => {
            if (value == "Y") {
                setGovesbUseYn(true);

                if (form.docChnlForm.getValue("trgtTpCd") === "B") {
                    grid.docTrscList.setEdit("cell", "apiCd", true);
                    grid.docTrscList.setEdit("cell", "pshCd", true);
                }
            } else {
                setGovesbUseYn(false);
                grid.docTrscList.setEdit("cell", "apiCd", false);
                grid.docTrscList.setEdit("cell", "pshCd", false);
            }
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        grid.docTrscList.setEdit("cell", "trgtIntfChnlId", false);
        //  grid.docTrscList.setOption("checkbox", false);
        grid.docTrscList.setOption("index", true);
    }, []);

    const statCd = form.docChnlForm.watch("chnlAplyPrcdStatCd");

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_SELC_SNDRCV"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.docChnlForm.schema.trgtTpCd} readOnly={true} />
                            {trgtTpCd !== "E" && (
                                <Group.Control {...form.docChnlForm.schema.sndrcvDvnCd} readOnly={true} />
                            )}
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            {trgtTpCd !== "E" && (
                <Group>
                    <Group.Body>
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_CHNL_INFO"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.intfChnlId} readOnly={true} />
                                <Group.Control {...form.docChnlForm.schema.chnlNm} readOnly={true} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.chnlIpAddr} />
                                <Group.Control {...form.docChnlForm.schema.chnlPortValue} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.chnlPrtclNm} />
                                <Group.Control {...form.docChnlForm.schema.chnlUrlAddr} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.actvtYn} />
                                <Group.Control
                                    {...form.docChnlForm.schema.chnlAplyPrcdStatCd}
                                    onChange={(value) => {
                                        form.docChnlForm.clearErrors();

                                        // If approved, reason for rejection is deleted !== 승인인 경우 반려사유 삭제 ==!
                                        if (form.docChnlForm.getValue("chnlAplyPrcdStatCd") === "C") {
                                            form.docChnlForm.setValue("rtrnRsn", "");
                                        }

                                        setChnlAplyPrcdStatCd(value);
                                    }}
                                />
                            </Group.Row>

                            {/* In case of rejection, set the reason for rejection to be visible !== 반려인 경우 반려사유 보이게 설정 ==! */}
                            <Group.Row hidden={statCd !== "D"}>
                                <Group.Control {...form.docChnlForm.schema.rtrnRsn} controlSize={10} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}

            {trgtTpCd !== "E" && (
                <Group>
                    <Group.Body>
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_IFAUTH_INFO"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control
                                    hidden={trgtTpCd !== "B"}
                                    {...form.docChnlForm.schema.govesbUseYn}
                                    onChange={(value) => {
                                        handler.onChangeGovesbUseYn(value);
                                    }}
                                />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.ifauthTpCd} />
                                <Group.Control {...form.docChnlForm.schema.tknUrl} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.tknId} />
                                <Group.Control {...form.docChnlForm.schema.tknSecrtKeyValue} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.chnlKeyCn} controlSize={10} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}

            {trgtTpCd !== "E" && (
                <Group>
                    <Group.Body>
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_USR_INFO"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.trgtTin} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.cntyCd} />
                                <Group.Control {...form.docChnlForm.schema.coCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.frstRegstId} readOnly={true} />
                                <Group.Control {...form.docChnlForm.schema.frstRgsrDtm} readOnly={true} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {trgtTpCd === "E" && (
                <Group>
                    <Group.Body>
                        <Layout>
                            <Layout.Left>
                                <Group.Title title={"T_CPA_INFO"} titleSize={2}></Group.Title>
                            </Layout.Left>
                        </Layout>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.cpaId} />
                                <Group.Control {...form.docChnlForm.schema.cpaCntyCd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.cpaSndrId} />
                                <Group.Control {...form.docChnlForm.schema.cpaSndrPwd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.cpaRcvrId} />
                                <Group.Control {...form.docChnlForm.schema.cpaRcvrPwd} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.parnEnpo} />
                                <Group.Control {...form.docChnlForm.schema.parnIp} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.ovstCagYn} />
                                <Group.Control {...form.docChnlForm.schema.ipYn} />
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.docChnlForm.schema.tansadBlckYn} />
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            {trgtTpCd !== "E" && (
                <Group>
                    <Group.Body>
                        <Layout>
                            <Layout.Left>
                                {comnUtils.isEmpty(sndrcvDvnCd) && (
                                    <Group.Title title={"T_INTF_DOC_LIST"} titleSize={2}></Group.Title>
                                )}
                                {sndrcvDvnCd == "A" && (
                                    <Group.Title title={"T_TRMSSN_INTF_DOC_LIST"} titleSize={2}></Group.Title>
                                )}
                                {sndrcvDvnCd == "B" && (
                                    <Group.Title title={"T_RCPN_INTF_DOC_LIST"} titleSize={2}></Group.Title>
                                )}
                                {sndrcvDvnCd == "C" && (
                                    <Group.Title title={"T_INTF_DOC_LIST"} titleSize={2}></Group.Title>
                                )}
                            </Layout.Left>
                            <Layout.Right>
                                {!comnUtils.isEmpty(sndrcvDvnCd) && (
                                    <Layout.Button role={"gridAdd"} onClick={handler.onGridAddBtnClick} />
                                )}
                                {!comnUtils.isEmpty(sndrcvDvnCd) && (
                                    <Layout.Button
                                        role={"gridDelete"}
                                        onClick={handler.click_Btn_DeleteGridDocTrscList}
                                    />
                                )}
                            </Layout.Right>
                        </Layout>
                        <Group.Section>
                            {trgtTpCd !== "D" && <Grid {...grid.docTrscList.grid} />}
                            {trgtTpCd === "D" && <Grid {...grid.traEdRcvrInfoList.grid} />}
                        </Group.Section>
                    </Group.Body>
                </Group>
            )}
            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ptli0705001q);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Button
                        role="save"
                        onClick={() => {
                            handler.onSaveBtnClick();
                        }}
                    ></Button>
                    <Layout.Button
                        role={"delete"}
                        onClick={() => {
                            handler.onDeleteBtnClick();
                        }}
                    />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
